import { SEND_FILE_SUCCESS } from './constants';

let sendFileState = {
};

const fileSender = (state = sendFileState, action) => {
    switch (action.type) {
        case SEND_FILE_SUCCESS : {
            sendFileState = {...action.result};
            return sendFileState;
        }
        default:
            return state;
    }
};

export { fileSender };